<button 
  mat-flat-button #btn 
  [autofocus]="btn.focus()" 
  [ngStyle]="{'min-width.px': minWidth}" 
  [class.confirmed-page]="isConfirmedPage">
    <mat-spinner *ngIf="isLoading" [diameter]="30"></mat-spinner>
    <span *ngIf="!isLoading">
      <ng-content></ng-content>
    </span>
    <!-- <mat-icon aria-hidden="false" *ngIf="!isLoading">keyboard_arrow_right</mat-icon> -->
</button>
